/**
 * Utility functions for Mix & Match pricing and selection validation.
 * Rule:
 * The unit price of a Mix & Match meal is the MAXIMUM category price
 * among all the categories from which items have been selected.
 */

export const calculateMixAndMatchPrice = (mixAndMatchItem, selectedItems = []) => {
  if (!mixAndMatchItem) return 0;

  if (!selectedItems || selectedItems.length === 0) {
    // If no selections, return the minimum category price as base/starting price
    const categoryPrices = mixAndMatchItem?.categories?.map((c) => Number(c.price || 0)) || [];
    if (categoryPrices.length > 0) {
      return Math.min(...categoryPrices);
    }
    return Number(mixAndMatchItem?.price || 0);
  }

  // Get category prices of all selected items
  const prices = selectedItems.map((sel) => Number(sel.category_price || sel.price || 0));
  if (prices.length === 0) {
    return Number(mixAndMatchItem?.price || 0);
  }

  // Highest tier price among chosen categories
  return Math.max(...prices);
};

export const getTotalMixAndMatchSelectionCount = (selectedItems = []) => {
  if (!Array.isArray(selectedItems)) return 0;
  return selectedItems.reduce((acc, item) => acc + (Number(item.quantity) || 1), 0);
};

export const getDefaultMixAndMatchSelections = (mixAndMatchItem) => {
  if (!mixAndMatchItem || !Array.isArray(mixAndMatchItem.categories)) return [];

  const maxChoose = Number(mixAndMatchItem.max_choose) || 1;
  const selections = [];
  let currentCount = 0;

  // Pick default items starting from the first available category
  for (const cat of mixAndMatchItem.categories) {
    if (currentCount >= maxChoose) break;
    if (Array.isArray(cat.items)) {
      for (const it of cat.items) {
        if (currentCount >= maxChoose) break;
        const itemId = typeof it === "object" ? it.id : it;
        const itemName = typeof it === "object" ? it.name : it;

        selections.push({
          category_id: cat.id,
          category_name: cat.category_name,
          category_price: Number(cat.price || 0),
          item_id: itemId,
          item_name: itemName,
          quantity: 1,
        });
        currentCount++;
      }
    }
  }

  return selections;
};
